import stringArray from 'string-array';

export class AiSuggest {
    length;

    constructor() {
        this.length = 'Large';
        if (aiSuggestActive && !document.querySelector('[data-scout-url]')) {
            this.initSuggestWysiwygOpenAiSuggest();
            this.addOpenAiSuggest();
        }
    }

    initSuggestWysiwygOpenAiSuggest() {
        $.Redactor.prototype.openaisuggest = function()
        {
            return {
                text: '',
                lang: '',
                answerlength: 'Extra small',
                init: function()
                {
                    var button = this.button.add('aisuggest', 'Ai Suggest');
                    this.button.setIcon(button, '<span class="icon ai-suggest"></span>');
                    this.button.addCallback(button, this.openaisuggest.openmodal);
                    this.button.disable('aisuggest');

                    this.opts.aisuggestJson = '/admin/artificialintelligence/ajax/suggest';

                    this.modal.addCallback('openaisuggest', this.openaisuggest.load);

                    this.openaisuggest.count();

                    this.core.editor().on('keyup.redactor', $.proxy(this.openaisuggest.count, this));
                },
                count: function(e = null) {
                    if (e != null) {
                        var key = e.which;
                        this.keyup.block = this.selection.block();
                        this.keyup.current = this.selection.current();
                        this.keyup.parent = this.selection.parent();
                        this.keyup.lastShiftKey = e.shiftKey;


                        // callback
                        var stop = this.core.callback('keyup', e);
                        if (stop === false)
                        {
                            e.preventDefault();
                            return false;
                        }

                        // replace a prev figure to paragraph if caret is before image
                        if (key === this.keyCode.ENTER)
                        {
                            return;
                        }

                        // linkify
                        if (this.linkify.isKey(key))
                        {
                            return;
                        }
                    }

                    let txt = this.$editor.html();
                    let words = 0;
                    txt = this.openaisuggest._clean(txt);
                    words = txt.split(/\s+/);
                    words = words ? words.length : 0;
                    if (words >= 3) {
                        this.openaisuggest.text = txt;
                        this.openaisuggest.lang = $('form .nav-item .nav-link.active').data('language');
                        this.button.enable('aisuggest');
                    } else {
                        this.button.disable('aisuggest');
                    }
                },
                _clean: function(t) {
                    return ((((((t.replace(/<\/(.*?)>/gi, " ")).replace(/<(.*?)>/gi, "")).replace(/\t/gi, "")).replace(/\n/gi, " ")).replace(/\r/gi, " ")).replace(/&nbsp;/g, "1")).trim();
                },
                openmodal: function() {
                    this.modal.load('openaisuggest', 'Suggest', 700);
                    $('#redactor-modal #ai-suggest-modal-form .btn.ajax-submit').on('click', this.openaisuggest.getsuggest);
                    $('#redactor-modal #ai-suggest-modal-form select[name="size"]').on('change', this.openaisuggest.getlength);
                    this.openaisuggest.answerlength = $('#redactor-modal #ai-suggest-modal-form select[name="size"]').find(':selected').val();
                    this.modal.show();
                },
                getlength: function(sel) {
                    this.openaisuggest.answerlength = $(sel.target).find(':selected').val();
                },
                load: function() {
                    let $box = $('.ai-suggest-modal-content').html();
                    this.modal.getModal().empty().append($box);
                },
                getsuggest: function(e) {
                    $('#redactor-modal #ai-suggest-modal-form .btn.ajax-submit').prop('disabled', true);
                    $('#redactor-modal #ai-suggest-modal-form #size-select').hide();
                    $('#redactor-modal #ai-suggest-modal-form .spinner-border').show();
                    let data = {
                        'lang': this.openaisuggest.lang,
                        'length': this.openaisuggest.answerlength,
                        'content': this.openaisuggest.text,
                    }
                    globalThis.that = this;
                    let jqxhr = $.post(this.opts.aisuggestJson, data)
                        .done(function(response) {
                            $('#redactor-modal #ai-suggest-modal-form .btn.ajax-submit').hide();
                            $('#redactor-modal #ai-suggest-modal-form #suggestion-text').show();
                            globalThis.that.openaisuggest.fillsuggestion($('#redactor-modal #ai-suggest-modal-form #suggestion-text #suggestion'), response[globalThis.that.openaisuggest.lang].text, 0);
                            $('#redactor-modal #ai-suggest-modal-form .btn.insert-suggestion').show();
                            $('#redactor-modal #ai-suggest-modal-form .btn.insert-suggestion').on('click', {response: response}, globalThis.that.openaisuggest.fillsuggestions);
                        })
                        .fail(function(response) {
                            $('#redactor-modal #ai-suggest-modal-form #size-select').show();
                            if (response.responseJSON) {
                                if (response.responseJSON.error) {
                                    alert(response.responseJSON.error);
                                } else {
                                    alert(response.responseJSON.message);
                                }
                                globalThis.that.modal.close();
                            } else {
                                console.log("error: " + response.responseText);
                            }
                        })
                        .always(function() {
                            $('#redactor-modal #ai-suggest-modal-form .spinner-border').hide();
                            $('#redactor-modal #ai-suggest-modal-form .btn.ajax-submit').prop('disabled', false);
                        });
                },
                fillsuggestion: function(element, text, counter){
                    if (
                        this.openaisuggest.answerlength === 'Extra small' ||
                        this.openaisuggest.answerlength === 'Small' ||
                        this.openaisuggest.answerlength == 'Medium'
                    ) {
                        if (counter < text.length) {
                            $(element).html($(element).html() + text.charAt(counter));
                            $(element).animate({
                                scrollTop: $(element).prop('scrollHeight')
                            }, 2)
                            counter++;
                            setTimeout(this.openaisuggest.fillsuggestion, 5, element, text, counter);
                        }
                    } else {
                        $(element).html(text);
                    }
                },
                fillsuggestions: function(e) {
                    for(let lang in e.data.response ) {
                        let redact = null;
                        let $langelement = $('.tab-pane textarea[name="translations['+ e.data.response[lang].code +'][text]"]');
                        if (!$langelement.length) {
                            $langelement = $('.tab-pane textarea[name="translations['+ e.data.response[lang].id +'][text]"]');
                        }
                        let $navtabvisible = $('.nav-tabs .nav-item .nav-link[data-language="'+ e.data.response[lang].code +'"]').is(':visible');
                        if ($langelement.length && $navtabvisible) {
                            for (let key in $langelement[0]) {
                                if (typeof $langelement[0][key] == 'object') {
                                    for (let obj in $langelement[0][key]) {
                                        if (obj === 'redactor') {
                                            redact = $langelement[0][key];
                                        }
                                    }
                                }
                            }
                            if (redact) {
                                let html = e.data.response[lang].text;
                                html = html.replace(/ \n/g, ' ');
                                html = html.replace(/\n /g, ' ');
                                $langelement.val(html);

                                html = this.paragraphize.load(html);

                                // remove empty p
                                html = html.replace(/<p><\/p>/g, '');
                                redact.redactor.selection.all();
                                redact.redactor.selection.replace(html);
                            } else {
                                $($langelement).val(lang.text)
                            }
                        }
                    }
                    this.modal.close();
                }
            };
        };
    };

    addOpenAiSuggest() {
        const $this = this;
        $('textarea.form-control.has-aisuggest').each(function(){
            let aisuggest_element = $(this);
            let lang = defaultLang;
            let modalbody = $('.ai-suggest-modal-content').html();
            let txt = $(this).val();
            let words = 0;
            words = txt.split(/\s+/);
            words = words ? words.length : 0;

            if($(this).closest('.language_tabs').length) {
                lang = $(this).closest('.language_tabs').find('.nav-item .active').data('language');
            }

            // Add button and modal to textarea
            let $id = $(this).prop('name').replace(/\[/g, '_').replace(/\]/g, '');
            $(this).parent().append('<button class="btn btn-secondary align-self-start" data-toggle="modal" data-target="#aiSuggest_'+$id+'" disabled><span class="icon ai-suggest"></span> '+aiSuggestTxt+'</button>\n' +
                '<div class="modal fade" id="aiSuggest_'+$id+'" tabindex="-1" role="dialog" aria-labelledby="aiSuggest_'+$id+'_Label" aria-hidden="true">\n' +
                '  <div class="modal-dialog" role="document">\n' +
                '    <div class="modal-content">\n' +
                '      <div class="modal-header">\n' +
                '        <h5 class="modal-title" id="aiSuggest_'+$id+'_Label">'+aiSuggestTxt+'</h5>\n' +
                '        <button type="button" class="close" data-dismiss="modal" data-bs-dismiss="modal" aria-label="Close" class="btn-close">\n' +
                '          <span aria-hidden="true">&times;</span>\n' +
                '        </button>\n' +
                '      </div>\n' +
                '      <div class="modal-body">\n' + modalbody + '\n' +
                '      </div>\n' +
                '    </div>\n' +
                '  </div>\n' +
                '</div>');

            let $button = $(this).parent().find('.btn.btn-secondary');

            $(this).on('keyup', function() {
                txt = $(this).val();
                let words = 0;
                words = txt.split(/\s+/);
                words = words ? words.length : 0;

                if (words >= 3) {
                    $button.prop('disabled', false);
                } else {
                    $button.prop('disabled', true);
                }
            });

            if (words >= 3) {
                $button.prop('disabled', false);
            } else {
                $button.prop('disabled', true);
            }

            $button.on('click', function(event){
                event.preventDefault();
                let modal = $(this).parent().find('.modal');
                modal.modal('toggle');
            });

            $('#aiSuggest_'+$id+' #ai-suggest-modal-form .btn.ajax-submit').on(
                'click',
                {
                    'modal': $('#aiSuggest_'+$id+' #ai-suggest-modal-form'),
                    'lang': lang,
                    'that' : $this,
                    'id': $id,
                    'element': aisuggest_element
                },
                $this.getSuggestions
            );
            $('#aiSuggest_'+$id+' #ai-suggest-modal-form select[name="size"]').on('change', {'that': $this}, $this.getLength);
            $('#aiSuggest_'+$id).on('hidden.bs.modal', {'id': $id, 'that': $this, 'lang': lang, 'element': aisuggest_element }, $this.resetModal);
        });
    };
    getLength(event) {
        event.preventDefault();

        let $this = event.data.that;
        if ($(this).find(':selected')) {
            $this.length = $(this).find(':selected').val();
        }
    };
    getSuggestions(event) {
        event.preventDefault();

        let modal = event.data.modal,
            lang = event.data.lang,
            $id  = event.data.id,
            length,
            text,
            element = event.data.element,
            data = [],
            jqxhr,
            $that = event.data.that;

        text = $(element).val();
        length = $that.length;
        data = {
            'lang': lang,
            'length': length,
            'content': text,
        }

        $(modal).find('.btn.ajax-submit').prop('disabled', true);
        $(modal).find('#size-select').hide();
        $(modal).find('.spinner-border').show();
        jqxhr = $.post('/admin/artificialintelligence/ajax/suggest', data)
            .done(function(response) {
                $(modal).find('.btn.ajax-submit').hide();
                $(modal).find('#suggestion-text').show();
                $that.fillSuggestion($that, $(modal).find('#suggestion-text #suggestion'), response[lang]['text'], 0, length);
                $(modal).find('.btn.insert-suggestion').show();
                $(modal).find('.btn.insert-suggestion').on('click', {response: response, lang: lang, element: element, id: $id}, $that.fillSuggestions)
            })
            .fail(function(response) {
                $(modal).find('#size-select').show();
                console.log( "error: "+response );
            })
            .always(function() {
                $(modal).find('.spinner-border').hide();
                $(modal).find('.btn.ajax-submit').prop('disabled', false);
            });
    };
    fillSuggestion($that, element, text, counter, length) {
        if (length === 'Extra small' || length === 'Small' || length === 'Medium') {
            if (counter < text.length) {
                $(element).html($(element).html() + text.charAt(counter));
                $(element).animate({
                    scrollTop: $(element).prop('scrollHeight')
                }, 2)
                counter++;
                setTimeout($that.fillSuggestion, 5, $that, element, text, counter, length);
            }
        } else {
            $(element).html(text);
        }
    };
    fillSuggestions(event) {
        event.preventDefault();

        let response = event.data.response,
            element_lang = event.data.lang,
            element = event.data.element,
            $id = event.data.id,
            multilang = false;

        const nameTemplate = stringArray.parse(element[0].closest('.form-group').querySelector('textarea.has-aisuggest').getAttribute('name'));

        for(let lang in response) {
            let name = `${nameTemplate.prefix}\\[${response[lang]['code']}\\]\\[${stringArray.parse(nameTemplate.remain).array[0]}\\]`;
            let $langelement = $(`.language_tabs .tab-pane textarea.has-aisuggest[name=${name}]`);
            let $navtabvisible = $('.nav-tabs .nav-item .nav-link[data-language="'+ response[lang]['code'] +'"]').is(':visible');
            
            if ($langelement.length && $navtabvisible) {
                if (!multilang) {
                    multilang = true;
                }
                $langelement.val(response[lang]['text']);
            }
        }

        if (!multilang) {
            element.val(response[element_lang]['text']);
        }

        $('#aiSuggest_'+$id).modal('toggle');
    };

    resetModal(event)
    {
        let $id = event.data.id,
            $this = event.data.that,
            lang = event.data.lang,
            aisuggest_element = event.data.element;

        $('#aiSuggest_'+$id+' .modal-body').html($('.ai-suggest-modal-content').html());
        $('#aiSuggest_'+$id+' #ai-suggest-modal-form .btn.ajax-submit').on(
            'click',
            {
                'modal': $('#aiSuggest_'+$id+' #ai-suggest-modal-form'),
                'lang': lang,
                'that' : $this,
                'id': $id,
                'element': aisuggest_element
            },
            $this.getSuggestions
        );
        $('#aiSuggest_'+$id+' #ai-suggest-modal-form select[name="size"]').on('change', {'that': $this}, $this.getLength);
    }
}
